var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruiterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66954 10.8343C2.77876 11.3564 0.443183 12.4225 1.86571 13.7566C2.56059 14.4082 3.33453 14.8743 4.30754 14.8743H9.85983C10.8328 14.8743 11.6067 14.4082 12.3016 13.7566C13.7241 12.4225 11.3886 11.3564 10.4978 10.8343C8.40895 9.60993 5.75841 9.60993 3.66954 10.8343Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91667 4.95833C9.91667 6.52314 8.64818 7.79167 7.08333 7.79167C5.51853 7.79167 4.25 6.52314 4.25 4.95833C4.25 3.39353 5.51853 2.125 7.08333 2.125C8.64818 2.125 9.91667 3.39353 9.91667 4.95833Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.734 5.525L15.584 6.375M15.159 4.0375C15.159 2.98125 14.3028 2.125 13.2465 2.125C12.1902 2.125 11.334 2.98125 11.334 4.0375C11.334 5.09375 12.1902 5.95 13.2465 5.95C14.3028 5.95 15.159 5.09375 15.159 4.0375Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiterIcon);
export default __webpack_public_path__ + "static/media/recruiter-icon.aaa6da6d0005fa7f64f5ba5061758bb5.svg";
export { ForwardRef as ReactComponent };